import {PlayerColor} from '@colonist/game-states'
import {ImageURL} from '@colonist/types'
import BgButtonRed from '@static/images/bg_button_red.svg'
import BgButtonBlue from '@static/images/bg_button_blue.svg'
import BgButtonGreen from '@static/images/bg_button_green.svg'
import BgButtonOrange from '@static/images/bg_button_orange.svg'
import BgButtonPurple from '@static/images/bg_button_purple.svg'
import BgButtonWhite from '@static/images/bg_button_white.svg'
import BgButtonBlack from '@static/images/bg_button_black.svg'
import BgButtonBronze from '@static/images/bg_button_bronze.svg'
import BgButtonSilver from '@static/images/bg_button_silver.svg'
import BgButtonGold from '@static/images/bg_button_gold.svg'
import BgButtonMysticBlue from '@static/images/bg_button_mysticblue.svg'
import BgButtonPink from '@static/images/bg_button_pink.svg'

export const BACKGROUND_TRADE_BUTTON_IMAGE: Record<PlayerColor, ImageURL> = {
    [PlayerColor.None]: '' as ImageURL,
    [PlayerColor.Red]: BgButtonRed,
    [PlayerColor.Blue]: BgButtonBlue,
    [PlayerColor.Orange]: BgButtonOrange,
    [PlayerColor.Green]: BgButtonGreen,
    [PlayerColor.Black]: BgButtonBlack,
    [PlayerColor.Bronze]: BgButtonBronze,
    [PlayerColor.Silver]: BgButtonSilver,
    [PlayerColor.Gold]: BgButtonGold,
    [PlayerColor.White]: BgButtonWhite,
    [PlayerColor.Purple]: BgButtonPurple,
    [PlayerColor.MysticBlue]: BgButtonMysticBlue,
    [PlayerColor.Pink]: BgButtonPink,
}

export const getCooldownOverlayClipPath = (percentage: number) => {
    if(percentage <= 0) return 'polygon(50% 50%, 50% 50%, 50% 50%)'
    if(percentage >= 100) return 'polygon(50% 50%, 50% 0%, 100% 0%, 100% 100%, 0% 100%, 0% 0%, 50% 0%)'

    const angle = (percentage / 100) * 360
    const centerX = 50
    const centerY = 50
    const radius = 100

    // Start from top (12 o'clock) and go clockwise
    const angleRad = ((angle - 90) * Math.PI) / 180
    const x = centerX + radius * Math.cos(angleRad)
    const y = centerY + radius * Math.sin(angleRad)

    let clipPath = `polygon(50% 50%, 50% 0%`

    // Add corner points based on angle
    if(angle > 45) clipPath += `, 100% 0%`
    if(angle > 135) clipPath += `, 100% 100%`
    if(angle > 225) clipPath += `, 0% 100%`
    if(angle > 315) clipPath += `, 0% 0%`

    // Add the calculated point
    clipPath += `, ${x}% ${y}%)`

    return clipPath
}
